import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'antd';
import { useAuth } from '../AuthContext';

const KEY = 'lc_cookie_consent';

/** 'all' = essential + marketing · 'essential' = essential only · null = not chosen yet. */
export const getConsent = () => {
  try {
    const v = (localStorage.getItem(KEY) || '').split('_')[0];
    // Anything else (e.g. the old notice-only "accepted") is not a real choice — ask again.
    return v === 'all' || v === 'essential' ? v : null;
  } catch (e) {
    return null;
  }
};

/** Reopen the banner from anywhere (footer link). */
export const openCookieSettings = () => window.dispatchEvent(new CustomEvent('lc:cookie-settings'));

/** Drop Meta's cookies when marketing consent is refused or withdrawn. */
const clearMarketingCookies = () => {
  try {
    const host = window.location.hostname;
    const domains = [host, '.' + host, '.' + host.replace(/^www\./, ''), ''];
    ['_fbp', '_fbc'].forEach((name) => {
      domains.forEach((d) => {
        document.cookie =
          name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (d ? '; domain=' + d : '');
      });
    });
  } catch (e) {}
};

const tx = {
  ar: {
    title: 'نحترم خصوصيتك',
    body: 'نستخدم ملفات تعريف ارتباط أساسية لتشغيل الموقع وحفظ جلستك. وبموافقتك نستخدم أيضاً ملفات تسويقية من Meta لقياس فعالية إعلاناتنا. إحصاءات الزيارات لدينا بدون كوكيز.',
    accept: 'أوافق على الكل',
    reject: 'الضرورية فقط',
    learn: 'سياسة الخصوصية',
  },
  en: {
    title: 'We respect your privacy',
    body: 'We use essential cookies to run the site and keep you signed in. With your consent we also use Meta marketing cookies to measure our ads. Our visit analytics are cookie-free.',
    accept: 'Accept all',
    reject: 'Essential only',
    learn: 'Privacy policy',
  },
};

export default function CookieConsent() {
  const auth = useAuth() || {};
  const lang = auth.lang || 'ar';
  const t = tx[lang] || tx.ar;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (!getConsent()) setTimeout(() => setShow(true), 900);
    const reopen = () => setShow(true);
    window.addEventListener('lc:cookie-settings', reopen);
    return () => window.removeEventListener('lc:cookie-settings', reopen);
  }, []);

  const choose = useCallback((value) => {
    try {
      localStorage.setItem(KEY, value + '_' + Date.now());
    } catch (e) {}
    if (value === 'all') {
      if (typeof window.__lcLoadPixel === 'function') window.__lcLoadPixel();
    } else {
      clearMarketingCookies();
    }
    setShow(false);
  }, []);

  if (!show) return null;

  return (
    <div className="cookie-banner" dir={lang === 'ar' ? 'rtl' : 'ltr'} role="dialog" aria-label={t.title}>
      <div className="cookie-banner-text">
        <b>{t.title}</b>
        <span>{t.body}</span>
        <a href="/legal/privacy">{t.learn}</a>
      </div>
      <div className="cookie-banner-actions">
        <Button size="middle" onClick={() => choose('essential')}>{t.reject}</Button>
        <Button size="middle" type="primary" onClick={() => choose('all')}>{t.accept}</Button>
      </div>
    </div>
  );
}
